// window.cgiftnote = "";

function giftWrapModal() {
  let giftcartItems = document.querySelector('#pf-cart-items');
  // gift cards footer
  const giftCards = document.querySelectorAll(
    ".gift_wrapper_drawer .cards .card"
  );

  giftCards.forEach((card) => {
    card.addEventListener("click", () => {
      giftCards.forEach((c) => {
        c.classList.remove("active");
      });

      card.classList.add("active");
    });
  });

  // cart drawer footer
  const wrapperTrigger = document.querySelector(
    "#cart-drawer .gift_wrapper_opener"
  );
  // gift wrapper header
  const wrapperCloser = document.querySelector(
    ".gift_wrapper_drawer .close_btn"
  );
  // gift wrapper
  const wrapper = document.querySelector(".gift_wrapper_drawer");

  // when gift wrapper opener trigger
  wrapperTrigger.addEventListener("click", () => {
    wrapper.classList.add("active");
  });

  // close the gift wrapper drawer
  wrapperCloser.addEventListener("click", () => {
    wrapper.classList.remove("active");
  });

  // add cart note
  const formSubmitBtn = document.querySelector(
    ".gift_wrapper_drawer .button_box .btn_primary"
  );

  // gift wrap footer
  const formCloseBtn = document.querySelector(
    ".gift_wrapper_drawer .button_box .btn_secondary"
  );

  // gift wrap footer note
  const textBox = document.querySelector(
    ".gift_wrapper_drawer .textarea_box textarea"
  );

  // when gift product atc trigger
  // formSubmitBtn.addEventListener("click", handleGiftSubmit);
  formSubmitBtn.onclick = handleGiftSubmit;

  // gift wrap footer close trigger 
  formCloseBtn.addEventListener("click", () => {
    wrapper.classList.remove("active");
    textBox.value = giftNote;
  });

  // gift wrap cart item selector [target]
  const giftProductCheckbox = document.querySelectorAll (
    ".gift_wrapper_drawer .pf-gift-cart-item" 
  );

  // gift wrap above the target 
  const giftProductDeselector = document.querySelector (
    ".gift_wrapper_drawer .pf-gift-cart-item-deselector"
  );

  // gift wrap cart items operations [target]
  if (giftProductCheckbox.length) {
    giftProductCheckbox.forEach((card) => {
      const checkbox = card.querySelector(".checkbox");
      
      checkbox.addEventListener("click", ()=>{
        if(card.classList.contains("active")){
          setTimeout(()=>{
            card.classList.remove("active");
          }, 500);
        } else {
          setTimeout(()=>{
            card.classList.add("active");
          }, 500);
        }
      });
    });

    giftProductDeselector.addEventListener("click", () => {
      let state = false;
      giftProductCheckbox.forEach((elm) => elm.classList.contains("active") ? state = true : null);

      setTimeout(()=>{
        if (state) {
          giftProductDeselector.innerHTML = "Selecteer al mijn artikelen";
          giftProductCheckbox.forEach(elm => elm.classList.remove("active"));
        } else {
          giftProductDeselector.innerHTML = "Deselecteer al mijn artikelen";
          giftProductCheckbox.forEach(elm => elm.classList.add("active"));
        }
      }, 1000)
    });
  }

  // cart drawer loader
  const CartLoader = {
    show() {
      const cartItems = document.querySelector("cart-items");
      cartItems?.classList.add("cart-items-is-loading");

      const showLoader = document.querySelector('[data-cart-loader-active="show"]');
      const hideLoader = document.querySelector('[data-cart-loader-active="hidden"]');

      showLoader?.classList.remove("hidden");
      hideLoader?.classList.add("hidden");

      document.activeElement?.blur();
    },

    hide() {
      const cartItems = document.querySelector("cart-items");
      cartItems?.classList.remove("cart-items-is-loading");

      const showLoader = document.querySelector('[data-cart-loader-active="show"]');
      const hideLoader = document.querySelector('[data-cart-loader-active="hidden"]');

      showLoader?.classList.add("hidden");
      hideLoader?.classList.remove("hidden");
    }
  };


  // Handle Gift submit
  function handleGiftSubmit() {
    // i have 3 cards. one should select
    const activeCard = document.querySelector(
      ".gift_wrapper_drawer .cards .card.active"
    );

    // title of selected card e.g boy, girl etc.
    const type = activeCard.getAttribute("title");

    // textBox is a textarea
    const giftNote = textBox.value;
    window.cgiftnote = giftNote;

    // gift wrap cart item selector [target]
    const giftProductCheckbox = document.querySelectorAll(
      ".gift_wrapper_drawer .pf-gift-cart-item"
    );

    let selectedItems = []

    // gift wrap cart item 
    giftProductCheckbox.forEach((item)=>{
      if(item.classList.contains("active")){
        const title = item.getAttribute("title");
        selectedItems.push(title);
      }
    })

    // explain me this line
    const note = selectedItems.length ? `${selectedItems.length} artikelen | ${type}${giftNote ? ` | incl. ${giftNote} ---` : " ---"} ${selectedItems.join(", ")}`
    : `${type}${giftNote ? ` | incl. ${giftNote}` : ""}`;

    // let note = "";
    // if (selectedItems.length > 0) {
    //   const itemCount = `${selectedItems.length} artikelen`;
    //   const cardType = type;
    //   const notePart = giftNote ? ` | incl. ${giftNote} ---` : " ---";
    //   const itemList = selectedItems.join(", ");

    //   note = `${itemCount} | ${cardType}${notePart} ${itemList}`;
    // } else {
    //   const cardType = type;
    //   const notePart = giftNote ? ` | incl. ${giftNote}` : "";

    //   note = `${cardType}${notePart}`;
    // }

    updateNote(note);
    // addGiftProduct();
    addGiftProduct().catch(() => {});

  }

  // async function addGiftProduct() {
  //   let notSelectedVariants = [];
  //   let selectedVariant;

  //   CartLoader.show();

  //   giftCards.forEach((card) => {
  //     // gift product variant id
  //     let giftProductId = card.getAttribute("value");
  //     if (card.classList.contains("active")) {
  //       selectedVariant = giftProductId;
  //     } else {
  //       notSelectedVariants.push(giftProductId);
  //     }
  //   });

  //   const res = await fetch("/cart.json");
  //   const cart = await res.json();
  //   // const removeFromCart = cart.items.filter((item)=> notSelectedVariants.includes(item.variant_id));
  //   const filterCart = cart.items.filter(
  //     (item) => item.variant_id == selectedVariant
  //   );

  //   const removePromises = cart.items
  //     .map((item, index) => {
  //       // if current unselected gift card is already in cart, remove it.
  //       if (notSelectedVariants.includes(item.variant_id.toString())) {
  //         return fetch("/cart/change.js", {
  //           method: "POST",
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //           body: JSON.stringify({
  //             line: index + 1, // Shopify uses 1-based line numbers
  //             quantity: 0,
  //           }),
  //         });
  //       }
  //       return null;
  //     })
  //     .filter(Boolean); // remove nulls

  //   await Promise.all(removePromises);

  //   if (filterCart.length) return 0;

  //   fetch("/cart/add.js", {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify({
  //       quantity: 1,
  //       id: selectedVariant,
  //     }),
  //   })
  //     .then((response) => {
  //       $("drawer-element").load(location.href + " #cart-drawer");
  //       console.log("gift product added to cart");
  //       let drawerEl = document.querySelector('drawer-element');
  //       console.log(drawerEl);
  //       CartLoader.hide();
  //       setTimeout(() => {
  //         // giftWrapModal();
  //       }, 300);
  //     })
  //     .catch((error) => {
  //       console.error("Error adding gift wrapper:", error);
  //     });
  // }

  async function addGiftProduct() {
    try {
      let notSelectedVariants = [];
      let selectedVariant;

      CartLoader.show();

      giftCards.forEach((card) => {
        let giftProductId = card.getAttribute("value");
        if (card.classList.contains("active")) {
          selectedVariant = giftProductId;
        } else {
          notSelectedVariants.push(giftProductId);
        }
      });

      const res = await fetch("/cart.json");
      const cart = await res.json();

      const filterCart = cart.items.filter(
        (item) => item.variant_id == selectedVariant
      );

      const removePromises = cart.items
        .map((item, index) => {
          if (notSelectedVariants.includes(item.variant_id.toString())) {
            return fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                line: index + 1,
                quantity: 0,
              }),
            });
          }
          return null;
        })
        .filter(Boolean);

      await Promise.all(removePromises);

      if (filterCart.length) {
        CartLoader.hide();
        return 0;
      }

      // Add selected gift
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          quantity: 1,
          id: selectedVariant,
        }),
      });

      $("drawer-element").load(location.href + " #cart-drawer");
      CartLoader.hide();
      console.log("gift product added to cart");
      const now = new Date();


    } catch (error) {
      // Critical part: DO NOT crash from SDK errors
      CartLoader.hide();
    }
  }

  function updateNote(note) {
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        note,
      }),
    })
      .then((response) => response.json())
      .then((cart) => {
        console.log("Note updated:", cart.note);
        if (textBox) {
          textBox.value = window.cgiftnote;
        }
        if (wrapper) {
          wrapper.classList.remove("active");
        }
      })
      .catch((error) => {
        console.error("Error updating cart note:", error);
      });
  }

  initSlider();
}

// Make sure this is global
window.clearNote = async function() {
  try {
    const response = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ note: "" }), // remove note
    });

    const cart = await response.json();
    console.log("Cart note cleared:", cart.note);
  } catch (error) {
    console.error("Error clearing cart note:", error);
  }
};


function initSlider(){
  const cartSlider = document.querySelectorAll(".pf-cart-related-product-slider");
  const cardSlider = document.querySelectorAll(".pf-product-card-slider-outer");
  
  if(cartSlider.length) {
    cartSlider.forEach((slide)=>{
      new Swiper(slide, {
        slidesPerView: 2.1,
        spaceBetween: 4,
        loop: true,
        navigation: {
          nextEl: slide.querySelector(".swiper-button-next"),
          prevEl: slide.querySelector(".swiper-button-prev"),
        },
      });
    });
  }

  if (cardSlider) {
    cardSlider.forEach((slide)=>{
      const pagination = slide.querySelectorAll(":scope > .swiper-pagination .swiper-pagination-bullet");
  
      const swiper = new Swiper(slide, {
        slidesPerView: 1,
        loop: true,
        navigation: {
          nextEl: slide.querySelector(":scope > .swiper-button-next"),
          prevEl: slide.querySelector(":scope > .swiper-button-prev"),
        },
        on: {
          slideChange(swiper) {
            // Clear existing active classes
            pagination.forEach((bullet) =>
              bullet.classList.remove("swiper-pagination-bullet-active")
            );
  
            // swiper.realIndex is the actual index (ignores duplicated looped slides)
            const activeIndex = swiper.realIndex % pagination.length;
  
            // Set the active bullet
            pagination[activeIndex]?.classList.add("swiper-pagination-bullet-active");
          },
        },
      });
    });
  }

  popUpLoader();
}


function popUpLoader() {
  const popUpOpeners = document.querySelectorAll('.pf-product-card .pf-quickshop-button-card');
  const popUpOpenersCart = document.querySelectorAll('.pf-product-card .pf-quickshop-button-cart');
  const selects = document.querySelectorAll('.pf_quickshop_modal_wrapper .pf-product-sizeBox .jb_size_seclector');
  const modals = document.querySelectorAll('.pf_quickshop_modal_wrapper');

  popUpOpeners.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      const card = btn.closest('.pf-product-card');
      const modal = card.querySelector('.pf_quickshop_modal_wrapper');

      modal.classList.add('active');
    });
  });

  popUpOpenersCart.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      const id = btn.getAttribute('product-id');
      const modal = document.querySelector(`.pf_quickshop_modal_wrapper[product-id="${id}"]`);
      
      if (modal) {
        document.querySelector("body").click();
        document.querySelector("body").click();
        modal.classList.add('active');
      }
    });
  });

  modals.forEach((modal) => {
    const closeBtn = modal.querySelector(".close_button");
    
    if (closeBtn) {
      closeBtn.addEventListener("click", () => {
        modal.classList.remove("active");
      });
    }

    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        modal.classList.remove('active');
      }
    });
  });

  selects.forEach((select) => {
    select.addEventListener('change', () => {
      const selectedValue = select.value;

      const modal = select.closest('.pf_quickshop_modal_wrapper');
      const input = modal.querySelector('product-form input[name="id"]'); // or use `.product-form` if it's a class
      const mainAtcButton = modal.querySelector('.product-form .product-form__buttons .button');
      const atcText = mainAtcButton.getAttribute("atc-text");
      const soldText = mainAtcButton.getAttribute("sold-text");

      if (!modal || !input) {
        console.warn('Modal or input not found.');
        return;
      }

      const variants = JSON.parse(modal.getAttribute('data-variants'));

      // Try to find the variant whose title or option matches selectedValue
      const matchedVariant = variants.find((variant) => {
        return variant.title.toLowerCase().includes(selectedValue.toLowerCase());
      });

      if (matchedVariant.available) {
        mainAtcButton.innerHTML = `<span data-add-to-cart-button-text=""><p>${atcText}</p></span>`;
        mainAtcButton.removeAttribute('disabled', false);
      } else {
        mainAtcButton.innerHTML = `<span data-add-to-cart-button-text=""><p>${soldText}</p></span>`;
        mainAtcButton.setAttribute('disabled', true);
      }

      if (matchedVariant) {
        input.value = matchedVariant.id;
      } else {
        console.warn('No matching variant found for value:', selectedValue);
      }
    });
  });

  function variantStatus(select) {
    const modal = select.closest('.pf_quickshop_modal_wrapper');
    const variants = JSON.parse(modal.getAttribute('data-variants'));

    console.log('select.value ====> ', select.value);
  }
}

// custom func observe cart drawer
function observeCartDrawer() {
  const cartDrawer = document.querySelector('cart-drawer'); // change selector if needed
  if (!cartDrawer) return;

  const observer = new MutationObserver(() => {
    let precom = document.querySelector('product-recommendations.product-recommendations .swiper-initialized');
    if(precom) return;
    const now = new Date();
    initSlider();
    giftWrapModal();
  });

  observer.observe(cartDrawer, {
    childList: true,     // watches for added/removed nodes
    subtree: true,       // watches all descendants
    attributes: true,    // watches for attribute changes
    characterData: true, // watches for text/content changes
  });
}

// Call it once after cart drawer is mounted
observeCartDrawer();
window.initSlider = initSlider;
window.giftWrapModal = giftWrapModal;
window.clearNote = clearNote;
